<template>
  <v-dialog :value="show" persistent max-width="496px" @input="close">
    <v-card class="break-delete">
      <div class="break-delete__header">
        <div class="break-delete__title">{{ adminText('workflowsAll.delete_break_5430c06', 'Delete break') }}</div>
        <v-icon class="break-delete__close" @click="close">close</v-icon>
      </div>
      <div class="break-delete__content">
        {{ adminText('workflowsAll.are_you_sure_you_want_to_delete_this_de38603', 'Are you sure you want to delete this') }} <strong>{{ workflowLabel(name) }}</strong
        >?
      </div>
      <div class="break-delete__actions">
        <main-button :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')" outline @click="close" />
        <main-button :text="adminText('workflowsAll.delete_f6fdbe4', 'Delete')" color="error" @click="confirm" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'break-delete-dialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // the break being deleted, or null while the dialog is closed
    breakItem: {
      type: Object,
      default: null,
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    name() {
      return (this.breakItem || {}).name || ''
    },
  },
  methods: {
    confirm() {
      this.onDelete()
      this.close()
    },
    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.break-delete {
  border-radius: 12px;
  padding: 24px;
}
.break-delete__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.break-delete__title {
  font-family: 'Raleway';
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -0.6px;
  color: #0277bd;
}
.break-delete__close {
  cursor: pointer;
}
.break-delete__content {
  margin-top: 4px;
  font-size: 16px;
  line-height: 1.5;
  color: #666666;
}
.break-delete__content strong {
  color: #333333;
}
.break-delete__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
}
</style>
